import "./Vision.scss";
import {Col, Container, Row} from "react-bootstrap";

const HomeCard = ({side = 'left', title, description, image, ...props}) => {

    console.log(side);
    console.log(props);

    return (
        <Container fluid={true} className={'py-5'}>
            <Container className={'py-lg-5 mw-100'}>
                <Row className={side === 'left' ? 'flex-row' : 'flex-row-reverse'}>
                    <Col lg={6}>
                        <div className="vision-text pb-5">
                            <div className="font-soria largePlainText vision-text-head">{title}</div>
                            <div className="smallPlainText flex" dangerouslySetInnerHTML={{ __html: "<p>" + description.replaceAll("\n","</p><p>") + "</p>" }} />
                        </div>
                    </Col>
                    <Col lg={6} className={'d-none d-sm-block'}>
                        <div className="vision-img">
                            <img
                                className="w-75 mw-100 rounded-3 float-lg-end"
                                alt="abc"
                                src={image}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default HomeCard;
